export type OntologyBuilderStatus = 'queued' | 'processing' | 'completed' | 'failed';

export interface OntologyBuilderStartResponse {
    status: string;
    session_id: string;
    status_url: string;
    websocket_url?: string;
}

export interface OntologyBuilderStatusResponse {
    session_id: string;
    status: OntologyBuilderStatus;
    progress: number;
    current_step?: string;
    message?: string;
    error?: string;
    ontology_json?: OntologyBuilderOutput;
    elapsed_seconds?: number;
}

export interface OntologyBuilderOutput {
    specialty: string;
    ontology_name: string;
    description?: string;
    fields: OntologyBuilderFieldDefinition[];
}

export interface OntologyBuilderFieldDefinition {
    field_name: string;
    display_name: string;
    description: string;
    data_type: string;
    extraction_instruction: string;
    example_values?: string[];
    required?: boolean;
    category: string;
}

export interface StartOntologyBuildRequest {
    specialty: string;
    ontology_name: string;
    instructions?: string;
    provider?: string;
    model?: string;
    use_agent?: boolean;
}

export interface OntologyBuilderJob {
    id: string;
    owner_id: string;
    specialty: string;
    ontology_name: string;
    instructions?: string | null;
    provider?: string | null;
    model?: string | null;
    use_agent?: boolean | null;
    session_id?: string | null;
    status: OntologyBuilderStatus;
    progress: number;
    current_step?: string | null;
    error_message?: string | null;
    result_data?: OntologyBuilderOutput | null;
    field_count?: number | null;
    created_at: string;
    updated_at: string;
    completed_at?: string | null;
}

export interface OntologyBuilderJobListResponse {
    jobs: OntologyBuilderJob[];
    total: number;
}
